/**
 * TicketDetailDrawer (#150) — clique no card do board abre o detalhe do ticket
 * num slide-over à direita (xl 960px, full no mobile), em vez de navegar pra
 * página inteira. Reusa `TicketDetailContent`.
 *
 * Migrado pro `Drawer` shared (F73/F75): portal no body, z-[60], tema claro
 * forçado (CSS vars override) e animação padrão. SEM barra própria de fechar
 * (DS 2026-08-11): `customHeader` vazio suprime o header default do Drawer e o
 * `TicketDetailHeader` em `variant="drawer"` (dentro do `TicketDetailContent`)
 * traz identidade + ações + X numa barra só, como o drawer de Detalhes do Lead.
 */

import React from 'react';

import { Drawer } from '@/shared/components/ui';

import { TicketDetailContent } from './TicketDetailContent';

interface TicketDetailDrawerProps {
  ticketId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export const TicketDetailDrawer: React.FC<TicketDetailDrawerProps> = ({ ticketId, isOpen, onClose }) => (
  <Drawer isOpen={isOpen && ticketId !== null} onClose={onClose} size="xl" customHeader={<></>}>
    {ticketId && (
      <div className="h-full overflow-hidden" data-testid="ticket-detail-drawer">
        <TicketDetailContent ticketId={ticketId} compact onCloseDrawer={onClose} isOpen={isOpen} />
      </div>
    )}
  </Drawer>
);
